import { useCallback } from "react";
import { useBrand } from "@/contexts/cdpConfig";
import { IS_SERVER, NOOP } from "@/constants";
import { useBrandUrl } from "./useBrandUrl";
export const useBackNavigation = () => {
    const brandId = useBrand();
    const baseUrl = useBrandUrl();
    return useCallback(() => {
        if (IS_SERVER)
            return NOOP;
        const { referrer } = window.document;
        const currentUrl = new URL(window.location.href);
        const serpView = currentUrl.searchParams.get("serp_view");
        const classifiedSearch = serpView === "map" ? "/classified-map?" : "/classified-search?";
        const search = currentUrl.searchParams.get("search");
        const url = `${baseUrl}${classifiedSearch}${search}`;
        if (referrer.includes(brandId) && window.history.length > 1) {
            window.history.back();
        }
        else if (search) {
            window.location.href = url;
        }
        else {
            window.location.href = baseUrl;
        }
    }, [brandId, baseUrl]);
};
